
import { LensInventory } from "@/types/inventory";
import { useIsMobile } from "@/hooks/use-mobile";
import { SortOption } from "./SortButton";
import { useTranslation } from "@/hooks/useTranslation";

interface MobileLensInventoryProps {
  lenses: LensInventory[];
  sortField: string;
  sortOrder: 'asc' | 'desc';
  onSort: (field: string) => void;
  onSortOrderChange: () => void;
  onActionComplete: () => void;
  renderItem: (item: LensInventory, index: number) => React.ReactNode;
  sortOptions: SortOption[];
}

export function MobileLensInventory({
  lenses,
  sortField = "brand",
  sortOrder = "asc",
  onSort = () => {},
  onSortOrderChange = () => {},
  onActionComplete,
  renderItem,
  sortOptions
}: MobileLensInventoryProps) {
  const isMobile = useIsMobile();
  const { t } = useTranslation();

  return (
    <div>
      <div className="space-y-3 mt-3 pb-20"> {/* Added padding bottom for mobile nav */}
        {lenses.length === 0 ? (
          <div className="text-center py-10 text-muted-foreground">
            {t('no_items_inventory')}
          </div>
        ) : (
          lenses.map((lens, index) => (
            <div key={lens.id || index} className="fade-in" style={{animationDelay: `${index * 50}ms`}}>
              {renderItem(lens, index)}
            </div>
          ))
        )}
      </div>
    </div>
  );
}
